export default {
  path: '/privacy-policy',
  name: 'PrivacyPolicy',
  component: () => import(/* webpackChunkName: "base/login" */ '../views/PrivacyPolicyView.vue'),
  meta: {
    layout: 'centered',
    exclude: true,
    requiresAuth: false,
    needsPermission: false
  }
}
